import { render } from "./AnnoncementIconSmall.vue?vue&type=template&id=66b25714"
import script from "./AnnoncementIconSmall.vue?vue&type=script&lang=js"
export * from "./AnnoncementIconSmall.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__